/**
 * F809 (Pete: 'pass a hint') - the WMS header links add `login_hint=<the account the person is signed in
 * with>`, so Microsoft offers THAT account instead of whichever one the browser used last (Pete was
 * offered his Symbia account, which is not in the Bardotek directory). Kept for this tab only
 * (sessionStorage) and taken off the address bar. ⛔ Only a hint: Microsoft still signs the person in,
 * and the API still checks their roles. Browser storage may be missing - every use is wrapped.
 */
const KEY = 'bardotek.loginHint';
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function captureLoginHint(): void {
    try {
        const u = new URL(window.location.href);
        const v = (u.searchParams.get('login_hint') ?? '').trim();
        if (!u.searchParams.has('login_hint')) return;
        if (EMAIL.test(v) && v.length <= 254) window.sessionStorage.setItem(KEY, v);
        u.searchParams.delete('login_hint');
        window.history.replaceState(window.history.state, '', u.toString());
    } catch { /* no storage or URL - Microsoft simply asks */ }
}

export function loginHint(): string | undefined {
    try { return window.sessionStorage.getItem(KEY) || undefined; } catch { return undefined; }
}
